<div class="editor">
  <!-- TIÊU ĐỀ MỞ RỘNG -->
  <div class="editor-header mt-0" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>

  <!-- ----------------------------------------------------------- MENU CONFIG ----------------------------------------------------------- -->
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config 
      [elementChoosing]="objectChoosing" 
      [device]="device"
      [id_parent_choose]="objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object">
    </app-position-out-config>

    <app-width-height-config 
      [device]="device" 
      [elementChoosing]="objectChoosing" 
      [width]="class['text-name']['width']"
      [height]="class['text-name']['height']" 
      (changeWidthHeight)="changeWidthHeight($event)">
    </app-width-height-config>

    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li nz-submenu [nzTitle]="'noi_dung' | translate" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <!-- chọn ngôn ngữ đa ngôn ngữ -->
        <div class="field-row mb-3">
          
        </div>
        <mat-form-field style="width: 100%">
          <mat-label>{{'noi_dung_khi_da_kich_hoat' | translate}}</mat-label>
          <textarea matInput 
            [ngModel]="staticdata['content_active_' + functionService.selectedLanguageCode] | vhLanguage : 'content_active' : objectChoosing.component" 
            (ngModelChange)="staticdata['content_active_' + functionService.selectedLanguageCode] = $event" 
            (blur)="updateContent('content_active')"></textarea>
        </mat-form-field>
        <mat-form-field style="width: 100%">
          <mat-label>{{'noi_dung_khi_chua_kich_hoat' | translate}}</mat-label>
          <textarea matInput 
            [ngModel]="staticdata['content_inactive_' + functionService.selectedLanguageCode] | vhLanguage : 'content_inactive' : objectChoosing.component" 
            (ngModelChange)="staticdata['content_inactive_' + functionService.selectedLanguageCode] = $event" 
            (blur)="updateContent('content_inactive')"></textarea>
        </mat-form-field>
      </li>

        <!-- CHỮ VÀ ĐỊNH DẠNG -->
      <li nz-submenu [nzTitle]="'chu_va_dinh_dang' | translate" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <!-- Hiển thị số dòng -->
        <div class="config-name mt-2">
          <p>{{'hien_thi_so_dong' | translate}} </p>
          <nz-input-number [nzMin]="1" [nzMax]="10" [nzStep]="1"
            [(ngModel)]="class['text-name__content']['-webkit-line-clamp']" 
            (nzBlur)="updateClass()">
          </nz-input-number>
        </div>

        <app-text-format-config 
          [device]="device" 
          [objectChoosing]="objectChoosing" 
          [class]="class"
          [config]="config" 
           
          [staticdata]="staticdata"
          [textContentClass]="class['text-name__content']" 
          [textWrapperClass]="class['text-name__wrapper']">
        </app-text-format-config>

        <!-- Gradient -->
        <div class="config-font">
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <p class="m-0" style="line-height:1.5">{{'do_mau_gradient' | translate}} <span style="font-size:13px">({{'da_sac' | translate}})</span></p>
            <nz-switch [(ngModel)]="config['background-image'].gradient_check"
              (ngModelChange)="handleSetGradientText()">
            </nz-switch>
          </div>
          <div class="container-gradient" *ngIf="config['background-image'].gradient_check">
            <div class="list-gradient">
              <button class="btn-gradient"
                *ngFor="let bgGradient of config['background-image']['gradient_arr_gradient']; let i = index"
                (click)="deleteGradient(i)" [ngStyle]="{'backgroundColor': bgGradient}"
                [disabled]="!config['background-image'].gradient_check">
                <i class="delete-icon bi bi-x-circle"></i>
              </button>
            </div>
            <p class="title-head">{{ 'them_mau' | translate }}</p>
            <div class="container_add-gradient">
              <button class="btn-add-gradient" nzTooltipTitle="{{ 'them_mau' | translate }}" nz-tooltip
                [disabled]="!config['background-image'].gradient_check" (click)="openbgGradient()"
                (blur)="addGradient()">
                <input nz-input type="color" class="picking-gradient" id="input-gradient"
                  [(ngModel)]="config['background-image']['gradient_background_color']">
                <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
              </button>
              <div class="slide_container-gradient">
                <input type="range" min="1" max="100" [value]="config['background-image']['gradient_opacity']"
                  class="slider-gradient" (input)="getValueRangeBackgroundGradient($event)"
                  [disabled]="!config['background-image'].gradient_check"
                  [ngStyle]="{background: 'linear-gradient(to right, transparent,#2764EB,#EFE810), url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)'}">
              </div>
              <div class="value-range">{{config['background-image']['gradient_opacity']}}%</div>
            </div>
            <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
            <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
              [nzTooltipTitle]="type.name" (click)="chooseOption(type, $event)"
              [disabled]="!config['background-image'].gradient_check"
              [style.background]="'linear-gradient('+ type.deg +', #2764EB, #EFE810)'"
              [ngClass]="{ 'active': config['background-image']['gradient_direction'] === type.direction}">
            </button>
          </div>
        </div>

        <!-- Khoảng cách chữ -->
        <app-letter-spacing-config
          [objectChoosing]="objectChoosing"
          [device]="device"
          [class]="class"
          [classLetterSpacing]="class['text-name__content']">
        </app-letter-spacing-config>

        <!-- Khoảng cách dòng -->
        <app-line-height-config
          [objectChoosing]="objectChoosing"
          [device]="device"
          [class]="class"
          [classLineHeight]="class['text-name__content']">
        </app-line-height-config>
      </li>

      <!-- PHONG CÁCH -->
      <li nz-submenu [nzTitle]="'phong_cach_va_kieu_co' | translate" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-text-style-config 
          [config]="config" 
          [class]="class" 
          [staticdata]="staticdata" 
          [device]="device"
          [objectChoosing]="objectChoosing" 
          [textContentClass]="class['text-name__content']"
          [textWrapperClass]="class['text-name']" 
          [filterConfig]="config['text-shadow']" 
          [isShape]="false">
        </app-text-style-config>
      </li>

      <!-- HIỆU ỨNG -->
      <li nz-submenu [nzTitle]="'hieu_ung' | translate" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-choose-animations-config
          [id_object]="objectChoosing._id" 
          [device]="device" 
          [class]="class" 
          [config]="config" 
          [staticdata]="staticdata"
          [cursorClass]="class['text-name']" 
          [effect_hover]="effect_hover" 
          [customize]="customize" 
          [type]="'object'"
          [effectFileUsing]="'text'"
          (openAnimationDetail)="openAnimationDetail($event)">
        </app-choose-animations-config>
      </li>

      <!-- THÊM LIÊN KẾT -->
      <li nz-submenu [nzTitle]="'them_lien_ket' | translate" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-link-page-config 
          [type_page]="['detail_product']" 
          [staticdata]="staticdata"
          [id_object]="objectChoosing._id">
        </app-link-page-config>
      </li>

      <!-- HIỂN THỊ -->
      <li nz-submenu [nzTitle]="'hien_thi' | translate" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
        </app-hide-show-config>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="this.config['animation-selected'].id != '000000'">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
  </div>
</div>